import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidatorFn,
} from "@angular/forms";
import { ServerService } from "../server.service";
import {
  DomSanitizer,
  SafeHtml,
  ɵangular_packages_platform_browser_platform_browser_k,
} from "@angular/platform-browser";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { ReporteBaremoService } from "../reporte-baremo.service";
import { Router, ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  form: FormGroup;
  modalRef: BsModalRef;

  ubicaciones: Array<any> = [];
  currentMun: Array<any> = [];
  zonas: number[] = [];
  preguntas: any[] = [];
  _encuesta: string = "";
  respuesta_lol: string = "";
  //add
  datos: any[] = [];
  instrucciones: any[] = [];
  id: number;
  private sub: any;

  lternate: boolean = true;
  toggle: boolean = true;
  color: boolean = false;
  size: number = 40;
  expandEnabled: boolean = true;
  contentAnimation: boolean = true;
  dotAnimation: boolean = true;
  side = "left";
  currentDesc = "";
  currentTime = 0;
  currentList = [];
  respuesta_id = 0;
  formData = true;
  formQuestion = false;
  perfilEncuestado = null;
  nombreEncuesta = "";
  requiereReporte = 0;
  sendAnswers: boolean = true;

  currentTimePoint: any = { currentDesc: "", time: 0 };
  modalCallback: () => void;

  public get encuesta(): SafeHtml {
    //  console.log("encuesta que viene desde home ",this.encuesta)
    //  console.log(this._encuesta)
    return this.sr.bypassSecurityTrustHtml(this._encuesta);
  }

  constructor(
    private fb: FormBuilder,
    private sr: DomSanitizer,
    private modalService: BsModalService,
    private server: ServerService,
    private baremoService: ReporteBaremoService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      currentDesc: [this.currentTimePoint.currentDesc, Validators.required],
      time: this.currentTimePoint.time,
    });
    // this.getUnidadesAcademicas();
    this.sub = this.route.params.subscribe((params) => {
      this.id = +params["id"];
    });
    this.requiereDatos(this.id);
    this.getPreguntas();
    this.getUbicaciones();
    this.fillZonas();
    this.requiredReport();

    

  }

  private updateForm() {
    this.form.setValue({
      currentDesc: this.currentTimePoint.name,
      time: this.currentTimePoint.time,
    });
  }

  private fillZonas() {
    for (var a = 1; a < 26; a++) {
      this.zonas.push(a);
    }
  }

  private requiereDatos(encuesta): boolean {
    this.server.getRequiereDatos(encuesta).subscribe((res: any) => {
      if (res[0].requiere_datos === 1) {
        this.formData = true;
        this.formQuestion = false;
        return true;
      }
    });
    this.formData = false;
    this.formQuestion = true;
    return false;
  }

  private getUbicaciones() {
    this.server.getUbicaciones().then((response: any) => {
      this.ubicaciones = response.map((ev) => {
        return ev;
      });
    });
  }

  getMunicipios(dept, pregunta) {
    pregunta.lista_respuestas = this.ubicaciones.find(
      (ub) => ub.departamento === dept
    ).municipios;
  }

  entries = [
    {
      header: "Universidad",
      content: "content",
      time: 0,
    },
  ];

  showQuestion(idPadre) {
    var flag = false;
    if (!idPadre) {
      return true;
    }

    var padres = String(idPadre).split(",").map(p => p.trim());
    this.preguntas.forEach((pregunta) => {
      switch (pregunta.tipo_pregunta) {
        case 1:
          if (pregunta.seleccion == idPadre) flag = true;
          break;
        default:
          pregunta.respuestas.forEach((element) => {
            padres.forEach((padre) => { 
              if (element.respuesta_id == padre && element.seleccionada == 1) {
                flag = true;
              }
          });
          });
          break;
      }
    });
    return flag;
  }

  //add

  showQuestions() {
    return this.formQuestion;
  }

  //add
  showDatos() {
    return this.formData;
  }

  addEntry(lista) {
    lista.push({
      numero: lista.length + 1,
      nombre: this.currentDesc,
      tiempo: this.currentTime,
    });
  }

  removeEntry(lista) {
    lista.pop();
  }

  onExpandEntry(expanded, index) {
    console.log(`Expand status of entry #${index} changed to ${expanded}`);
  }

  onHeaderClick(event) {
    if (!this.expandEnabled) {
      event.stopPropagation();
    }
  }

  onDotClick(event) {
    if (!this.expandEnabled) {
      event.stopPropagation();
    }
  }

  toggleSide() {
    this.side = this.side === "left" ? "right" : "left";
  }

  drop(event: CdkDragDrop<string[]>, list: any[]) {
    //moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
    this.moveInList(list, event.previousIndex, event.currentIndex);
  }

  moveInList(list: any[], previousIndex: number, currentIndex: number) {
    list.splice(currentIndex, 0, list.splice(previousIndex, 1)[0]);
  }

  private getPreguntas() {
    this.server.getPreguntas(this.id).then((response: any) => {
      this.preguntas = response.preguntas;
      this.datos = response.datos;
      this.instrucciones = response.instrucciones;
      this.nombreEncuesta = this.instrucciones[0].nombre;
    });
  }
  addTimeEntry() {
    this.toggleSide();

    this.currentList.push({
      numero: this.currentList.length + 1,
      nombre: this.currentDesc,
      tiempo: this.currentTime,
      respuesta_id: this.respuesta_id,
    });

    this.modalRef.hide();
    this.currentTime = 0;
  }

  checkBoxChange(respuesta) {}

  HideOptionIfSelected(pregunta, val: number) {
    var flag = true;
    pregunta.respuestas.forEach((element) => {
      if (parseInt(element.prioridad) == val) {
      }
    });
    return flag;
  }

  checkDatos() {
    var registro,
      nombres,
      apellidos,
      genero,
      cui,
      tipo_encuestado_id = 1,
      curso,
      seccion,
      carrera,
      fecha;
    var flag = true;
    const encuestaId = Number(this.route.snapshot.paramMap.get('id'));
    this.datos.forEach((dato) => {
      if (dato.obligatorio == 1) {
        if (dato.respuesta != "" && dato.respuesta != null) {
          if (dato.codigo_campo == "Carné") {
            registro = dato.respuesta;
          } else if (dato.codigo_campo == "Nombres") {
            nombres = dato.respuesta;
          } else if (dato.codigo_campo == "Apellidos") {
            apellidos = dato.respuesta;
          } else if (dato.codigo_campo == "Género") {
            if (dato.respuesta == "Masculino") {
              genero = 1;
            } else {
              genero = 0;
            }
          } else if (dato.codigo_campo == "CUI") {
            cui = dato.respuesta;
          } else if (dato.codigo_campo == "Carrera") {
            carrera = dato.respuesta;
          } else if (dato.codigo_campo == "Sección") {
            seccion = dato.respuesta;
          } else if (dato.codigo_campo == "Curso") {
            curso = dato.respuesta;
          } else if (dato.codigo_campo == "Fecha de Nacimiento") {
            fecha = dato.respuesta;
          }
          dato.error = false;
        } else {
          console.log("error: " + dato.codigo_campo);
          dato.error = true;
          flag = false;
        }
      } else {
        if (dato.codigo_campo == "Carné") {
          registro = dato.respuesta;
        } else if (dato.codigo_campo == "Nombres") {
          nombres = dato.respuesta;
        } else if (dato.codigo_campo == "Apellidos") {
          apellidos = dato.respuesta;
        } else if (dato.codigo_campo == "Género") {
          if (dato.respuesta == "Masculino") {
            genero = 1;
          } else {
            genero = 0;
          }
        } else if (dato.codigo_campo == "CUI") {
          cui = dato.respuesta;
        } else if (dato.codigo_campo == "Carrera") {
          carrera = dato.respuesta;
        } else if (dato.codigo_campo == "Sección") {
          seccion = dato.respuesta;
        } else if (dato.codigo_campo == "Curso") {
          curso = dato.respuesta;
        } else if (dato.codigo_campo == "Fecha de Nacimiento") {
          fecha = dato.respuesta;
        }
        console.log(dato.tipo_campo);
        console.log(dato.codigo_campo + ": " + dato.respuesta);
        dato.error = false;
      }
    });
    if (!flag) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Existen preguntas sin contestar, por favor verifique sus respuestas.",
      });
    } else {
      this.server.getEncuestado(registro,encuestaId).subscribe(data => {
        if (data.id[0].existe) {
          Swal.fire(
            "Registro ya existe",
            "Este usuario ya ha respondido la encuesta.",
            "error"
          );
          return null;
        }
        this.formData = false;
        this.formQuestion = true;
        Swal.fire(
          "¡Datos Recibidos!",
          "Sus datos han sido recibidos con exito.",
          "success"
        );
      });
    }
  }

  async checkAnswers() {
    this.fillQuestions();
    var flag = true;
    this.preguntas.forEach((pregunta) => {
      if (pregunta.obligatoria == 1 && pregunta.lista_respuestas.length == 0) {
        flag = false;
        pregunta.error = true;
      }

      if (pregunta.tipo_pregunta == 3) {
        if (
          pregunta.obligatoria == 1 &&
          (pregunta.respuestas[0].seleccionada == 0 ||
            !pregunta.respuestas[0].respuesta_valor2)
        ) {
          flag = false;
          pregunta.error = true;
        }
      }
    });

    if (!flag) {
      this.preguntas.forEach((pregunta) => {
        if (!(pregunta.tipo_pregunta === 3 || pregunta.tipo_pregunta === 7)) {
          pregunta.lista_respuestas = [];
        }
      });
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Existen preguntas sin contestar, por favor verifique sus respuestas.",
      });
    } else {
      this.sendAnswers = false;

      await this.server
        .insertAnswer(this.datos, this.id)
        .then(async (response: any) => {
          this.perfilEncuestado = response.id;
          await this.server
            .createInstance(this.preguntas, this.perfilEncuestado)
            .then(async () => {
              sessionStorage.setItem("encuesta", this.id.toString());
              sessionStorage.setItem("perfil", this.perfilEncuestado);
            });
        });

      if (this.requiereReporte == 1) {
        await this.baremoService.getInterpretacion(
          this.id,
          this.perfilEncuestado
        );
        this.sendAnswers = true;
        this.router.navigate(["/reporte"]);
      } else {
        this.sendAnswers = true;
        Swal.fire(
          "¡Encuesta completada!",
          "Sus respuestas han sido recibidos con exito.",
          "success"
        ).then((res) => {
          window.location.reload();
        });
      }
    }
  }

  fillQuestions() {
    this.preguntas.forEach((pregunta) => {
      pregunta.error = false;
      switch (pregunta.tipo_pregunta) {
        case 0:
          pregunta.respuestas.forEach((respuesta) => {
            if (respuesta.tipo_respuesta == 5) {
              if (parseInt(respuesta.respuesta_valor) > -1) {
                pregunta.lista_respuestas.push(respuesta);
              }
            } else {
              if (respuesta.respuesta_valor) {
                pregunta.lista_respuestas.push(respuesta);
              }
            }
          });
          break;
        case 1:
          pregunta.respuestas.forEach((respuesta) => {
            if (pregunta.seleccion == respuesta.respuesta_id) {
              pregunta.lista_respuestas.push(respuesta);
            }
          });
          break;
        case 2:
          pregunta.respuestas.forEach((respuesta) => {
            if (respuesta.seleccionada) {
              pregunta.lista_respuestas.push(respuesta);
            }
          });
          break;
        case 4:
          pregunta.respuestas.forEach((respuesta) => {
            if (respuesta.prioridad !== -1) {
              pregunta.lista_respuestas.push(respuesta);
            }
          });
          break;
        case 5:
          pregunta.respuestas.forEach((respuesta) => {
            if (respuesta.respuesta_valor) {
              pregunta.lista_respuestas.push(respuesta);
            }
          });
        case 7:
          pregunta.respuestas.forEach((respuesta) => {
            if (respuesta.respuesta_valor && respuesta.respuesta_valor2) {
              if (pregunta.lista_respuestas.length === 0) {
                pregunta.lista_respuestas.push(respuesta);
              }
            }
          });
          case 8:
            pregunta.respuestas.forEach(respuesta => {
              if(respuesta.seleccionada)  {
                pregunta.lista_respuestas.push(respuesta);
              }
            });
          break;
          case 9:
            pregunta.respuestas.forEach(respuesta => {
              if(respuesta.respuesta_valor > 0 && respuesta.respuesta_Valor < 6)  {
                pregunta.lista_respuestas.push(respuesta);
              }
            });
            case 10:
            pregunta.respuestas.forEach(respuesta => {
              if(respuesta.respuesta_valor != "")  {
                pregunta.lista_respuestas.push(respuesta);
              }
            });

      }
    });
  }

  requiredReport() {
    this.baremoService.getPlantilla(this.id).then((response: any) => {
      this.requiereReporte = response[0].reporte_requerido;
    });
  }

  open(template, desc, lista, respuesta_id) {
    this.modalRef = this.modalService.show(template);
    this.currentDesc = desc;
    this.currentList = lista;
    this.respuesta_id = respuesta_id;
    this.form.get("currentDesc").setValue(desc);
  }

  createUnidadAcademica() {
    const newPointTime = {
      currentDesc: this.form.get("currentDesc").value,
      time: this.form.get("time").value,
    };
    this.modalRef.hide();
    this.server.createUnidadAcademica(newPointTime).then(() => {
      this.entries.push({
        header: newPointTime.currentDesc,
        content: "",
        time: newPointTime.time,
      });
    });
  }

  onCancel() {
    this.modalRef.hide();
  }

  getItems(pregunta: any): string[] {
    return pregunta?.pregunta_descripcion2
      ? pregunta.pregunta_descripcion2.split('&&').map(b => b.trim())
      : [];
  }
  
  isChecked(valor: string, item: string): boolean {
    if (!valor) return false;
    return valor.split('&&').map(b => b.trim()).includes(item.trim());
  }
  
  toggleItem(respuesta: any, item: string): void {
    const selected = respuesta.respuesta_valor
      ? respuesta.respuesta_valor.split('&&').map(b => b.trim())
      : [];
  
    const index = selected.indexOf(item.trim());
  
    if (index > -1) {
      // Uncheck
      selected.splice(index, 1);
    } else {
      // Check
      selected.push(item.trim());
    }
  
    // Update the respuesta_valor string
    respuesta.respuesta_valor = selected.join('&&');
  }
  
  showBaseOnAnswer(answerId: any): boolean {
    if (answerId == null || answerId == 0) return true;
  
    for (const pregunta of this.preguntas) {
      for (const respuesta of pregunta.respuestas) {
        if (respuesta.respuesta_id === answerId && respuesta.seleccionada) {
          return true;
        }
      }
    }
  
    return false;
  }


  getSelectedCount(respuesta: any): number {
    return respuesta.respuesta_valor
      ? respuesta.respuesta_valor.split('&&').filter(v => v.trim() !== '').length
      : 0;
  }
  
  isDisabled(respuesta: any, item: string, pregunta: any): boolean {
    // Already selected? Never disable it
    const isAlreadyChecked = this.isChecked(respuesta.respuesta_valor, item);
  
    // Get current selected count
    const count = this.getSelectedCount(respuesta);
  
    // Disable if not checked AND max reached
    return !isAlreadyChecked && count >= pregunta.max_respuestas;
  }

  isSelected(selected: any) {
    if(selected==1) return true; 
    return false;
  }
  
}

